<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { FeatureDepositGeneralCalculator } from '~/components/feature/deposit/general-calculator'
import { ContentBlock } from '~/components/ui/content-block'
import { WidgetSelectDepositType } from '~/components/widget/select-deposit-type'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetDepositsBestOffers } from '~/components/widget/best-offers'
import { WidgetDepositSelectionCta } from '~/components/widget/deposit-selection-cta'

const { t } = useI18n()

const breadcrumbs = computed(() => [
  { title: t('common.deposits_label'), url: '/deposits' },
  { title: t('menu.deposits.calculator'), url: '/deposits/calculator' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            <WidgetSelectDepositType
              :query-params="{
                'filter[position]': 'sidebar'
              }"
            />
          </aside>
        </template>
        <div>
          <div class="space-y-5" role="main">
            <section>
              <ContentBlock
                variant="white"
                :heading-text="t('page.deposits_calculator.heading')"
                heading-tag="h1"
              >
                <p v-hydrated-html="t('page.deposits_calculator.description_1')" />
                <p v-hydrated-html="t('page.deposits_calculator.description_2')" class="font-semibold" />

                <FeatureDepositGeneralCalculator />
              </ContentBlock>
              <WidgetDepositSelectionCta class="mt-5" />
              <WidgetDepositsBestOffers />
            </section>
          </div>
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
